import {
  Autocomplete,
  Button,
  Card,
  CardContent,
  Dialog,
  FormControl,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  TextareaAutosize,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useContext, useState, useEffect } from "react";
import { TextFieldMA } from "../../styles/styledComponents";
import { theme } from "../../styles/theme";
import { font } from "../../styles/font";
import { ApplicationContext } from "../../context/application_ctx";
import { HttpStatusCode } from "axios";
import { GlobalSnackBar } from "../../components/snackBar";
import { ButtonCustom } from "../../components/button";
import { SubscriptionDialog } from "../../components/subscriptionDialog";
import { LicenceTickIcon } from "../../svgIcons/icons";
import dayjs from "dayjs";
import { Cancel } from "@mui/icons-material";
import {
  contactUs,
  getAssignAdmin,
} from "../../api/controllers/dashboardController";
import {
  paymentRequest,
  updateLicencePurchase,
} from "../../api/controllers/userController";
import { useNavigate } from "react-router-dom";
export const Licence = ({ profileDetails }) => {
  const navigate = useNavigate();
  const {
    setGlobalLoader,
    selectedNoOfEmployees,
    setSelectedNoOfEmployees,
    licenceBatchList,
    setAssignDetails,
    confirmPurchase,
  } = useContext(ApplicationContext);
  console.log(licenceBatchList, "batchonreload");
  let licenceDetails = licenceBatchList[licenceBatchList?.length - 1];

  let expiryDate = dayjs(
    licenceBatchList[licenceBatchList?.length - 1]?.expirationDate
  )?.format("YYYY MM DD");
  let currentDate = dayjs(new Date()).format("YYYY MM DD");
  let finaldays = dayjs(expiryDate).diff(dayjs(currentDate), "days");
  // console.log( 'expiry',expiry,current  ,dayjs(expiry).diff(dayjs(current),'days'),'totaldays')

  const licenceQuery = useMediaQuery("(max-width:450px)");

  const [contactDialog, setContactDialog] = useState(false);
  const [profileSnack, setProfileSnack] = useState(false);
  // const [subDialog, setSubDialog] = useState(false);
  const [error, setError] = useState("");
  // const [subscriptionNav, setSubscriptionNav] = useState(false);
  const [selectMail, setSelectMail] = useState(null);
  const [contactUsQuery, setContactUsQuery] = useState(null);
  const [currentPlan, setCurrentPlan] = useState({});

  // const [selectedNoOfEmployees, setSelectedNoOfEmployees] = useState(20);
  const [subscriptionType, setSubscriptionType] = useState("annually");
  const [standardPlanPrice, setStandardPlanPrice] = useState();
  const [purchaseDialog, setPurchaseDialog] = useState(false);

  let amount =
    Number.isNaN(selectedNoOfEmployees) === false
      ? (
          (selectedNoOfEmployees > 185 ? 185 : selectedNoOfEmployees) *
          standardPlanPrice
        ).toFixed(2)
      : standardPlanPrice;
  let discount = ((amount * profileDetails?.discount) / 100).toFixed(2);
  let finalAmount = (amount - discount).toFixed(2);

  const handleChangeSubscriptionType = (event) => {
    setSubscriptionType(event.target.value);
  };

  let subscriptionCard = [
    {
      planType: "Trial",
      description: "A free 21 days demo of Mindamgio",
      price: "£0",
      priceDescription: "Per user",
      morePriceDescription: "",
      buttonText: "Start trial",
      features: [
        { name: "A free trial of Mindamigo for up to 20 users for 21 days" },
        // { name: "1-month free trail" },
        // { name: "1-month free trail" },
        // { name: "1-month free trail" },
      ],
    },
    {
      planType: "Standard",
      description: "For organisations with 1-185 employees",
      price: `£${
        Number.isNaN(selectedNoOfEmployees) === false
          ? (
              (selectedNoOfEmployees > 185 ? 185 : selectedNoOfEmployees) *
              standardPlanPrice
            ).toFixed(2)
          : 0
      }`,
      priceDescription: "Per year",
      morePriceDescription: "",
      buttonText: "Select plan",
      features: [
        { name: "User access to Mindamigo and all its features" },
        { name: "User friendly platform to manage employee access and impact" },
        {
          name: `Meet the mental health needs of your employees \n with ACT and CBT`,
        },
        {
          name: "Keep a track of how you’re feeling over time to ensure Mindamigo is working for you",
        },
      ],
    },
    {
      planType: "Contact us",
      description: "For organisations with 186+ employees",
      price: "£0",
      priceDescription: "",
      morePriceDescription:
        "For more than 185 employees get in touch with the team",
      buttonText: "Contact us",
      features: [
        { name: "User access to Mindamigo and all its features" },
        { name: "User friendly platform to manage employee access and impact" },
        {
          name: "Meet the mental health needs of your employees with ACT and CBT",
        },
        {
          name: "Keep a track of how you’re feeling over time to ensure Mindamigo is working for you",
        },
      ],
    },
  ];
  console.log(selectedNoOfEmployees, "getderails");

  useEffect(() => {
    setStandardPlanPrice(
      (finaldays > 365 || licenceBatchList?.length === 1 ? 365 : finaldays) *
        0.136958904109
    );
  }, [licenceBatchList]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    //setGlobalLoader(true);

    setTimeout(() => {
      setGlobalLoader(false);
    }, 2000);
    // profileDetails.isOnDemo = true
    // profileDetails.isPaymentDone = false
    // console.log(profileDetails.isPaymentDone, "doneee");
    if (licenceDetails?.isDemo) {
      setCurrentPlan(subscriptionCard[1]);
    } else {
      setCurrentPlan(subscriptionCard[2]);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // if(Number.isNaN(selectedNoOfEmployees)) {
    //   setSelectedNoOfEmployees(1)
    // }

    // if (selectedNoOfEmployees < 20) {
    //   setCurrentPlan(subscriptionCard[0])
    // }

    if (selectedNoOfEmployees >= 1 && selectedNoOfEmployees < 186) {
      setCurrentPlan(subscriptionCard[1]);
    }

    if (selectedNoOfEmployees > 185) {
      setCurrentPlan(subscriptionCard[2]);
    }
  }, [selectedNoOfEmployees]); // eslint-disable-line react-hooks/exhaustive-deps
  console.log(
    selectedNoOfEmployees,
    "noofemplyees",
    Number.isNaN(selectedNoOfEmployees)
  );

  console.log(licenceQuery, "licenceQuery");

  const apiSubscribeLicence = async (plans) => {
    console.log(
      dayjs().isAfter(profileDetails.licenseExpirationDate),
      "datecheclk"
    );

    if (plans.planType === "Contact us") {
      console.log("contact use");
      setContactDialog(true);
    } else if (!selectedNoOfEmployees || selectedNoOfEmployees === "0") {
      setError("No of Licence can't be empty");
      setProfileSnack(true);
    }
    // else if (
    //   profileDetails.isPaymentDone &&
    //   plans.planType === "Standard" &&
    //   dayjs().isBefore(profileDetails.licenseExpirationDate)
    // ) {
    //   setError("You are already subscribed to this plan");
    //   setProfileSnack(true);
    // }
    else if (plans.planType === "Contact us") {
      console.log("enterprise");
    } else {
      // setSubDialog(true);
      // handleAddress();
      setPurchaseDialog(true);

      // try {
      //   let response = await licencePurchase(
      //     {
      //       numberOfLicenses: selectedNoOfEmployees,
      //       paymentAmount:
      //         Number.isNaN(selectedNoOfEmployees) === false
      //           ? (
      //               (selectedNoOfEmployees > 185
      //                 ? 185
      //                 : selectedNoOfEmployees) * standardPlanPrice
      //             ).toFixed(2)
      //           : standardPlanPrice,
      //     },
      //     localStorage.getItem("api-token")
      //   );
      //   console.log(response, "responseLogin");
      //   if (response.status === HttpStatusCode.Ok) {
      //     // setLoaderState(false);
      //     setError(response.data.message);
      //     setProfileSnack(true);
      //     setReloadProfile(true);
      //     setTimeout(() => {
      //       setReloadProfile(false);

      //       setSubDialog(true);

      //       setClientSecret(response.data.clientSecret);
      //     }, 2000);

      //     // setSignInSnack(true);
      //     // setConfirmModal(false);
      //     // localStorage.setItem("api-token", tokenTemp);
      //     // setTimeout(() => {
      //     //   //   navigate("/dashboard");
      //     //   setLoginNavigation(4);
      //     // }, 3000);
      //   }
      //   if (response.status === HttpStatusCode.BadRequest) {
      //     // setLoaderState(false);

      //     setError(response.data.message);
      //     // setSignInSnack(true);
      //   }
      // } catch (error) {
      //   console.log(error);
      // }
    }
  };

  const postContactUs = async () => {
    try {
      let response = await contactUs({
        query: selectMail.queryType,
        message: contactUsQuery,
      });
      console.log(response, "resp");
      if (response.status === HttpStatusCode.Created) {
        setError(
          "Your Query is sent to our representative, we will contact you soon"
        );
        setProfileSnack(true);
        setContactDialog(false);
        assignedAdmin();
        handleCloseContact();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const assignedAdmin = async (id) => {
    setGlobalLoader(true);

    try {
      let response = await getAssignAdmin();
      console.log(response, "getAssignees");
      if (response.status === HttpStatusCode.Ok) {
        setTimeout(() => {
          setGlobalLoader(false);
        }, 2000);
        setAssignDetails(response?.data);
        // setFilteredList(response.data);
      }
      // if (response.status === HttpStatusCode.Unauthorized) {
      //   navigate("/signin");
      // }

      // setEmployeesData(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  console.log(!selectedNoOfEmployees, "checkkkit");
  console.log(profileDetails?.hasAvailedDemo, "checkkk");
  let contactUsMails = [
    {
      queryType: "Licence purchase & extension",
      id: 0,
      email: "adam.chadwick@mindamigo.com",
      mailTO:
        "mailto:uniquetyagi6@gmail.com.com?&subject=Summer%20Party&body=You%20are%20invited%20to%20a%20big%20summer%20party1!",
    },
    {
      queryType: "Employee on-boarding & off-boarding",
      id: 1,
      email: "adam.chadwick@mindamigo.com",
      mailTO:
        "mailto:uniquetyagi6@gmail.com.com?&subject=Summer%20Party&body=You%20are%20invited%20to%20a%20big%20summer%20party2!",
    },
    {
      queryType: "Other",
      id: 3,
      email: "manoj.yadav@mindamigo.com",
      mailTO:
        "mailto:uniquetyagi6@gmail.com.com?&subject=Summer%20Party&body=You%20are%20invited%20to%20a%20big%20summer%20party3!",
    },
  ];

  // const handleMailTo = (data) => {
  //   setMailTo(data.mailTO);
  //   if (data.mailType === "primary") {
  //     document.getElementById("mail0").click();
  //   }
  //   if (data.mailType === "Secondary") {
  //     document.getElementById("mail1").click();
  //   }
  //   if (data.mailType === "Alternate") {
  //     document.getElementById("mail2").click();
  //   }
  //   console.log("sent");
  // };
  console.log(selectMail, "mail");
  const handleCloseContact = () => {
    setContactDialog(false);
    setSelectMail(null);
  };

  console.log(profileDetails, "detailsls");
  const handleAddress = async () => {
    setPurchaseDialog(false);
    setGlobalLoader(true);
    try {
      let response = await paymentRequest(
        {
          organizationId: profileDetails?._id,
          requestedLicenses: selectedNoOfEmployees,
          amount:finalAmount
          //  address: address.value,
        },
        localStorage.getItem("api-token")
      );
      console.log(response, "responseLogin");
      if (response.status === HttpStatusCode.Ok) {
        sessionStorage.setItem("redirect-url", response?.data?.redirectUrl);
        navigate("/dashboard/redirect-url");
        setGlobalLoader(false);

        // setLoaderState(false);
        //  setAddressSwitch(true);
        //  setError(response.data.message);
        //  setProfileSnack(true);
        //  setReloadProfile(true);
        //  setTimeout(() => {
        //    setReloadProfile(false);

        //    // setSubDialog(true);

        //    setClientSecret(response.data.clientSecret);
        //  }, 2000);

        // setSignInSnack(true);
        // setConfirmModal(false);
        // localStorage.setItem("api-token", tokenTemp);
        // setTimeout(() => {
        //   //   navigate("/dashboard");
        //   setLoginNavigation(4);
        // }, 3000);
      }
      if (response.status === HttpStatusCode.BadRequest) {
        // setLoaderState(false);
        setGlobalLoader(false);

        setProfileSnack(true);
        setError(response.data.message);
        // setSignInSnack(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    console.log("hello enter");
    if (confirmPurchase) {
      const apiSubscribeLicence = async (plans) => {
        try {
          let response = await updateLicencePurchase(
            {
              numberOfLicenses: selectedNoOfEmployees,
              paymentAmount:finalAmount,
            },
            localStorage.getItem("api-token")
          );
          console.log(response, "responseLoginFInal");
          if (response.status === HttpStatusCode.Ok) {
            // setLoaderState(false);
            navigate("/dashboard");

            // setSignInSnack(true);
            // setConfirmModal(false);
            // localStorage.setItem("api-token", tokenTemp);
            // setTimeout(() => {
            //   //   navigate("/dashboard");
            //   setLoginNavigation(4);
            // }, 3000);
          }
          if (response.status === HttpStatusCode.BadRequest) {
            // setLoaderState(false);
            // setSignInSnack(true);
          }
        } catch (error) {
          console.log(error);
        }
      };
      apiSubscribeLicence();
    }
  }, [confirmPurchase]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <>
      <Box
        display="flex"
        width="100%"
        height="100%"
        flexDirection="column"
        sx={{ height: "fit-content" }}
      >
        {/* licence container */}
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap={4}
          // justifyContent="center"

          // border={`1px solid ${theme.bgBorder}`}
          border={`1px solid ${theme.col_2_alpha}`}
          borderRadius="8px"
          backgroundColor={theme.col_4}
          height="100%"
          width="100%"
          p={4}
        >
          {/* current plan */}
          <Box display="flex" width="100%">
            <Card sx={{ width: "100%", height: "100%", borderRadius: "8px" }}>
              <CardContent>
                <Box width="100%" display="flex" flexDirection="column">
                  <Typography
                    variant="h6"
                    color={theme.col_3}
                    fontWeight="bold"
                  >
                    Current Plan
                  </Typography>
                  <Typography variant="body2" color={theme.col_6}>
                    Change your plan according to your need
                  </Typography>

                  {/* current plan */}
                  <Box
                    display="flex"
                    // flexDirection="column"
                    mt={2}
                    border={`1px solid ${theme.bgBorder}`}
                    borderRadius="8px"
                    px={1}
                    py={2}
                    gap="15px"
                  >
                    <Box
                      display="flex"
                      flexDirection="column"
                      paddingRight="12px"
                      borderRight={
                        licenceBatchList?.length > 1
                          ? `2px solid ${theme.col_2}`
                          : "0"
                      }
                    >
                      <Box display="flex" alignItems="center" gap={2}>
                        <Box
                          display="flex"
                          alignItems="flex-start"
                          gap={0.4}
                          flex={1}
                        >
                          <Typography
                            variant="h5"
                            color={theme.col_2}
                            fontWeight="bold"
                          >
                            Trial
                          </Typography>

                          {dayjs().isAfter(
                            licenceBatchList[0]?.expirationDate
                          ) ? (
                            <Typography
                              fontSize={font.size.fs_4}
                              color={"red"}
                              fontWeight="bold"
                            >
                              {"Expired"}
                            </Typography>
                          ) : (
                            <></>
                          )}
                        </Box>
                      </Box>

                      <Box display="flex" alignItems="center" gap="5px">
                        <Typography
                          fontSize={font.size.fs_4}
                          fontWeight="bold"
                          color={theme.col_6}
                        >
                          Valid up to:{" "}
                        </Typography>
                        <Typography
                          fontSize={font.size.fs_4}
                          color={theme.col_6}
                        >
                          {" "}
                          {dayjs(licenceBatchList[0]?.expirationDate).format(
                            "DD MMMM YYYY"
                          )}
                        </Typography>
                      </Box>
                    </Box>
                    {licenceBatchList?.length > 1 ? (
                      <Box display="flex" flexDirection="column">
                        <Box display="flex" alignItems="center" gap={2}>
                          <Box
                            display="flex"
                            alignItems="flex-start"
                            gap={0.4}
                            flex={1}
                          >
                            <Typography
                              variant="h5"
                              color={theme.col_2}
                              fontWeight="bold"
                            >
                              Standard
                            </Typography>

                            {dayjs().isAfter(
                              licenceBatchList[licenceBatchList?.length - 1]
                                ?.expirationDate
                            ) ? (
                              <Typography
                                fontSize={font.size.fs_4}
                                color={"red"}
                                fontWeight="bold"
                              >
                                {"Expired"}
                              </Typography>
                            ) : (
                              <></>
                            )}
                          </Box>
                        </Box>

                        <Box display="flex" alignItems="center" gap="5px">
                          <Typography
                            fontSize={font.size.fs_4}
                            fontWeight="bold"
                            color={theme.col_6}
                          >
                            Valid up to:{" "}
                          </Typography>
                          <Typography
                            fontSize={font.size.fs_4}
                            color={theme.col_6}
                          >
                            {" "}
                            {dayjs(
                              licenceBatchList[licenceBatchList?.length - 1]
                                ?.expirationDate
                            ).format("DD MMMM YYYY")}
                          </Typography>
                        </Box>
                      </Box>
                    ) : (
                      <></>
                    )}
                  </Box>
                </Box>
              </CardContent>
            </Card>

            {/* <Box display="flex" alignItems="center" border={`1px solid ${theme.bgBorder}`}>
              last payment
            </Box> */}
          </Box>

          {/* no of employees */}
          <Box
            display={"flex"}
            flexDirection="column"
            justifyContent="center"
            height="100%"
            gap={2}
            // border="2px solid blue"
          >
            <Box
              display={"flex"}
              flexDirection={licenceQuery ? "column" : "row"}
              alignItems="center"
              justifyContent="center"
              height="100%"
              gap={licenceQuery ? 2 : 6}
              // border="2px solid blue"
            >
              <Typography
                fontSize={font.size.fs_6}
                fontFamily={font.family.fm_2}
                fontWeight="bold"
                color={theme.col_2}
              >
                How many users are in your team?
              </Typography>
              <TextFieldMA
                type="number"
                size="small"
                value={selectedNoOfEmployees}
                onChange={(e) => {
                  // const newValue = Math.max(
                  //   1,
                  //   parseFloat(
                  //     e.target.value > 1000000 ? 1000000 : e.target.value
                  //   )
                  // );

                  setSelectedNoOfEmployees(
                    e.target.value < 0
                      ? 1
                      : e.target.value > 10000
                      ? 10000
                      : e.target.value
                  );
                }}
                inputProps={{
                  min: 1,
                }}
              />
            </Box>

            <Box
              display={"flex"}
              flexDirection={licenceQuery ? "column" : "row"}
              alignItems="center"
              // justifyContent="center"
              height="100%"
              gap={licenceQuery ? 2 : 2.8}
              pl={0}
              // border="2px solid blue"
            >
              <Typography
                fontSize={font.size.fs_6}
                fontFamily={font.family.fm_2}
                fontWeight="bold"
                color={theme.col_2}
              >
                How often would you like to be billed?
              </Typography>
              <FormControl>
                {/* <FormLabel id="demo-controlled-radio-buttons-group">Gender</FormLabel> */}
                <RadioGroup
                  row
                  aria-labelledby="demo-controlled-radio-buttons-group"
                  name="controlled-radio-buttons-group"
                  value={subscriptionType}
                  onChange={handleChangeSubscriptionType}
                >
                  {/* <FormControlLabel value="monthly" control={<Radio />} label="Monthly" /> */}
                  <FormControlLabel
                    disabled={currentPlan?.planType === "Trial"}
                    value="annually"
                    control={<Radio />}
                    label="Annually"
                  />
                </RadioGroup>
              </FormControl>
            </Box>
          </Box>

          {/* subscription */}
          <Box
            display={"flex"}
            justifyContent="center"
            // width="92%"
            height="100%"
            gap={4}
            flexWrap="wrap"

            // border="2px solid blue"
          >
            {subscriptionCard?.map((plans, i) => {
              return (
                <>
                  <Box
                    key={i}
                    display={"flex"}
                    flexDirection="column"
                    minWidth="201px"
                    maxWidth="300px"
                    gap={3.2}
                    borderRadius="25px"
                    bgcolor={
                      currentPlan?.planType === plans?.planType ||
                      plans.planType === "Trial"
                        ? theme.col_2_alpha2
                        : theme.col_14_alpha
                    }
                    overflow="hidden"
                    padding={2.2}
                    sx={{
                      cursor:
                        plans.planType === "Trial" ? "not-allowed" : "pointer",
                    }}
                  >
                    <Box
                      display={"flex"}
                      paddingBottom="8px"
                      flexDirection="column"
                      alignItems="center"
                      p={2}
                      m={1}
                      gap={1}
                      bgcolor={
                        currentPlan?.planType === plans?.planType ||
                        plans.planType === "Trial"
                          ? theme.col_2
                          : theme.col_14
                      }
                      borderRadius="14px"

                      // border="2px solid blue"
                    >
                      <Typography
                        fontFamily={font.family.fm_2}
                        // textTransform={"capitalize"}
                        fontSize={font.size.fs_5}
                        fontWeight="bold"
                        color={theme.col_4}
                      >
                        {plans?.planType}
                      </Typography>
                      <Typography
                        fontFamily={font.family.fm_2}
                        // textTransform={"capitalize"}
                        fontSize={font.size.fs_3}
                        // fontWeight="bold"
                        color={theme.col_4}
                        textAlign="center"
                        width={i === 0 ? "92%" : "80%"}

                        // border="2px solid blue"
                      >
                        {plans?.description}
                      </Typography>
                    </Box>

                    <Box
                      display={"flex"}
                      m={1}
                      flexDirection="column"
                      alignItems="center"
                      justifyContent="center"
                      height="78px"
                      // border="2px solid blue"
                    >
                      {!plans.morePriceDescription && (
                        <Typography
                          flex="1"
                          lineHeight={1}
                          sx={{ wordBreak: "break-all" }}
                          fontFamily={font.family.fm_2}
                          // textTransform={"capitalize"}
                          fontSize={font.size.fs_1}
                          fontWeight="bold"
                          color={
                            currentPlan?.planType === plans?.planType ||
                            plans.planType === "Trial"
                              ? theme.col_2
                              : theme.col_14
                          }
                          textAlign="center"
                        >
                          {selectedNoOfEmployees > 185 &&
                          plans.planType === "Standard"
                            ? plans.price
                            : plans.price}
                        </Typography>
                      )}
                      {!plans.morePriceDescription && (
                        <Typography
                          fontFamily={font.family.fm_2}
                          // textTransform={"capitalize"}
                          fontSize={font.size.fs_3}
                          fontWeight="bold"
                          color={theme.col_6}
                          textAlign="center"
                        >
                          {plans?.priceDescription}
                        </Typography>
                      )}

                      {plans?.morePriceDescription && (
                        <Typography
                          fontFamily={font.family.fm_2}
                          // textTransform={"capitalize"}
                          fontSize={font.size.fs_3}
                          fontWeight="bold"
                          color={theme.col_6}
                          textAlign="center"
                          // height="88px"
                        >
                          {plans?.morePriceDescription}
                        </Typography>
                      )}
                    </Box>

                    <Box
                      display={"flex"}
                      alignItems="center"
                      justifyContent="center"
                      mx={1}
                    >
                      {plans.planType === "Trial" ? (
                        <>
                          <Typography
                            fontFamily={font.family.fm_2}
                            // textTransform={"capitalize"}
                            // fontSize={font.size.fs_5}
                            display="flex"
                            alignItems="center"
                            fontWeight="bold"
                            height="52px"
                            textAlign="center"
                            color={theme.col_2}
                            fontSize="18px"

                            // border="2px solid blue"
                          >
                            Automatically applied
                          </Typography>
                        </>
                      ) : (
                        <Button
                          disableElevation
                          disableFocusRipple
                          disableRipple
                          disableTouchRipple
                          fullWidth
                          // disabled={Number.isNaN(selectedNoOfEmployees)}
                          disabled={
                            currentPlan.planType === plans.planType
                              ? false
                              : true
                          }
                          // disabled={ (selectedNoOfEmployees > 20 && selectedNoOfEmployees <= 185 && plans.planType === 'Employee') || (selectedNoOfEmployees > 185  && plans.planType === 'Contact us')  ? false :  true  }

                          sx={{
                            //  background: plans?.planType === "Trial" || (profileDetails?.isPaymentDone && plans.planType === 'Employee' )?  theme.col_4  : currentPlan.planType === plans?.planType  ? theme.col_2 : theme.col_14,
                            background:
                              currentPlan.planType === plans.planType
                                ? theme.col_2
                                : theme.col_4,
                            // visibility:
                            //   plans.planType === "Trial" ? "hidden" : "visible",
                            // background: (selectedNoOfEmployees > 20 && selectedNoOfEmployees <= 185 && plans.planType === 'Employee') || (selectedNoOfEmployees > 185  && plans.planType === 'Contact us')   ? theme.col_2 : theme.col_4,
                            border: `2px solid transparent`,
                            color:
                              currentPlan.planType === plans.planType
                                ? theme.col_4
                                : theme.col_5,
                            borderRadius: "20px",
                            px: 4,
                            textTransform: "initial",
                            fontSize: "18px",
                            "&:hover ": {
                              color:
                                currentPlan.planType === plans?.planType
                                  ? theme.col_2
                                  : theme.col_3,
                              border:
                                currentPlan.planType === plans?.planType
                                  ? `2px solid ${theme.col_2}`
                                  : `2px solid ${theme.col_3}`,
                            },
                          }}
                          onClick={() => apiSubscribeLicence(plans)}
                        >
                          {plans?.buttonText}
                        </Button>
                      )}
                    </Box>

                    <Box
                      display={"flex"}
                      flexDirection="column"
                      // paddingBottom='8px'
                      gap="3px"
                      px={1}
                      position="relative"

                      // border="2px solid blue"
                    >
                      {plans.features.map((feat, index) => {
                        return (
                          <Box
                            display={"flex"}
                            paddingBottom="8px"
                            gap="32px"
                            alignItems="center"
                            justifyContent="flex-start"
                          >
                            {/* <CheckCircleIcon
                              sx={{
                                color: JSON.stringify(plans) === JSON.stringify(currentPlan) ? theme.col_2 : theme.col_3,
                              }}
                            /> */}

                            <Box maxWidth="10%">
                              <LicenceTickIcon
                                // style={{
                                //   color: JSON.stringify(plans) === JSON.stringify(currentPlan) ? theme.col_2 : theme.col_3,
                                //   width: "40px",
                                // }}
                                color={
                                  currentPlan.planType === plans?.planType ||
                                  plans.planType === "Trial"
                                    ? theme.col_2
                                    : theme.col_3
                                }
                              />
                            </Box>

                            <Typography
                              fontFamily={font.family.fm_2}
                              // textTransform={"capitalize"}
                              fontSize={font.size.fs_3}
                              fontWeight="bold"
                              color={theme.col_6}
                              width={index === 2 ? "72%" : "78%"}
                              // border="2px solid blue"
                            >
                              {feat.name}
                            </Typography>
                          </Box>
                        );
                      })}
                    </Box>
                  </Box>
                </>
              );
            })}

            {/* {profileDetails.isOnDemo ? (
              <ButtonCustom
                onClick={() => setSubDialog(true)}
                fullWidth={false}
                disabled={false}
                // loaderState={loaderState}
                borderRadius="42px"
                size="large"
                background={theme.col_2}
                backgroundRipple={theme.col_3}
                focusColor={theme.col_1}
                display="flex"
                alignItems="center"
                justifyContent="center"
                typography={
                  <Typography
                    fontFamily={font.family.fm_2}
                    textTransform={"capitalize"}
                    fontSize={font.size.fs_3}
                    fontWeight="bold"
                    color={theme.col_4}
                  >
                    Upgrade
                  </Typography>
                }
              />
            ) : (
              <></>
            )} */}
          </Box>
        </Box>
      </Box>

      <Dialog
        open={purchaseDialog}
        // fullWidth
        maxWidth={"100%"}
        maxheight={"100%"}
        PaperProps={{
          style: {
            maxHeight: "100%",
            width: "509px",
          },
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          pb={3}
          gap="13px"
          width="100%"
          backgroundColor={theme.col_4}
        >
          <Box
            display="flex"
            flexDirection="column"
            gap={2}
            padding="12px 0px 20px 0px"
            width="90%"
            backgroundColor={theme.col_4}
            alignItems="center"
          >
            <Box
              display="flex"
              justifyContent="center"
              width="100%"
              alignItems="center"
            >
              <Typography
                fontFamily={font.family.fm_2}
                // textTransform={"capitalize"}
                fontSize={font.size.fs_5}
                fontWeight="bold"
                color={theme.col_3}
                flex="1"
              >
                Purchase Info
              </Typography>
              <IconButton onClick={() => setPurchaseDialog(false)}>
                <Cancel sx={{ fontSize: "32px", color: theme.col_2 }} />
              </IconButton>
            </Box>
            <Typography
              fontFamily={font.family.fm_2}
              textAlign="center"
              fontSize={font.size.fs_5}
              fontWeight="bold"
              color={theme.col_2}
              flex="1"
            >
              Confirm to proceed the payment
            </Typography>
            <Box display="flex" flexDirection="column" gap={"6px"}>
              <Typography
                variant="h6"
                display="flex"
                fontWeight="bold"
                gap="4px"
                color={theme.col_2}
                textAlign="center"
                alignItems="center"
              >
                Amount:
                <Typography variant="h6" color={theme.col_3} textAlign="center">
                  &pound;
                  {amount}
                </Typography>
                <Typography
                  backgroundColor={theme.col_2}
                  borderRadius="45px"
                  fontSize={font.size.fs_3}
                  color={theme.col_4}
                  px={1}
                  py={0.4}
                >
                  &pound;{discount} OFF
                </Typography>
              </Typography>
              <Typography
                variant="h6"
                display="flex"
                fontWeight="bold"
                gap="4px"
                color={theme.col_2}
                textAlign="center"
              >
                Total Amount:
                <Typography variant="h6" color={theme.col_3} textAlign="center">
                  &pound;
                  {finalAmount}
                </Typography>
              </Typography>
              <Typography
                variant="h6"
                display="flex"
                gap="4px"
                fontWeight="bold"
                color={theme.col_2}
                textAlign="center"
              >
                No of licences:
                <Typography variant="h6" color={theme.col_3} textAlign="center">
                  {selectedNoOfEmployees}
                </Typography>
              </Typography>
              <Typography
                variant="h6"
                display="flex"
                gap="4px"
                fontWeight="bold"
                color={theme.col_2}
                textAlign="center"
              >
                Licence type:
                <Typography variant="h6" color={theme.col_3} textAlign="center">
                  {currentPlan.planType}
                </Typography>
              </Typography>
            </Box>
          </Box>
          <ButtonCustom
            borderRadius={"45px"}
            width={"83px"}
            height="35px"
            minWidth="83px"
            // fullWidth={true}
            onClick={handleAddress}
            typography={
              <Typography
                fontFamily={font.family.fm_2}
                textTransform={"capitalize"}
                fontSize={font.size.fs_4}
                fontWeight="bold"
                color={theme.col_2}
              >
                Confirm
              </Typography>
            }
            // onClick={handleDemo}
            background={theme.col_2_alpha}
            backgroundRipple={theme.col_2_alpha}
          />
        </Box>
      </Dialog>

      <Dialog
        open={contactDialog}
        // fullWidth
        maxWidth={"100%"}
        maxheight={"100%"}
        PaperProps={{
          style: {
            maxHeight: "100%",
            width: "609px",
          },
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap="13px"
          width="100%"
          backgroundColor={theme.col_4}
        >
          <Box
            display="flex"
            flexDirection="column"
            gap={2}
            padding="12px 0px 20px 0px"
            width="90%"
            backgroundColor={theme.col_4}
          >
            <Box
              display="flex"
              justifyContent="center"
              width="100%"
              alignItems="center"
            >
              <Typography
                fontFamily={font.family.fm_2}
                // textTransform={"capitalize"}
                fontSize={font.size.fs_5}
                fontWeight="bold"
                color={theme.col_3}
                flex="1"
              >
                Contact us
              </Typography>
              <IconButton onClick={handleCloseContact}>
                <Cancel sx={{ fontSize: "32px", color: theme.col_2 }} />
              </IconButton>
            </Box>
            <Box
              display="flex"
              // justifyContent="center"
              width="100%"
              flexDirection="column"
              gap={"14px"}
              alignItems="center"
            >
              {/* {contactUsMails.map((data, i) => {
                return (
                  <Box
                    display="flex"
                    // justifyContent="center"
                    width="100%"
                    height="50px"
                    // backgroundColor='red'
                    borderRadius="12px"
                    alignItems="center"
                    border={`3px solid ${theme.col_2_alpha}`}
                    position="relative"
                    px={2}
                  >
                    <a id={`mail${i}`} target="_top" href={data.mailTO}></a>
                    <Box
                      display="flex"
                      justifyContent="center"
                      // width="100%"
                      // backgroundColor='red'
                      flexDirection={"column"}
                      borderRadius="12px"
                      flex={1}
                      // alignItems="center"
                    >
                      <Box
                        display="flex"
                        // justifyContent="center"
                        // width="60px"
                        px={2}
                        position="absolute"
                        top="-9px"
                        // height='60px'
                        // backgroundColor='red'
                        borderRadius="12px"
                        alignItems="center"
                        backgroundColor={theme.col_2_alpha_alt}
                      >
                        <Typography
                          fontFamily={font.family.fm_2}
                          textTransform={"capitalize"}
                          fontSize={font.size.fs_4}
                          fontWeight="bold"
                          color={theme.col_2}
                          // flex="1"
                        >
                          {data.mailType}
                        </Typography>
                      </Box>
                      <Typography
                        fontFamily={font.family.fm_2}
                        textTransform={"capitalize"}
                        fontSize={font.size.fs_4}
                        fontWeight="bold"
                        color={theme.col_3}
                        // flex="1"
                      >
                        {data.email}
                      </Typography>
                    </Box>
                    <AttachEmailIcon
                      onClick={() => handleMailTo(data)}
                      sx={{ color: theme.col_2 }}
                    />
                  </Box>
                );
              })} */}
              <Autocomplete
                id="country-select-demo"
                // sx={{ width: 300 }}
                // fullWidth
                sx={{ width: "100%" }}
                value={selectMail}
                // getOptionSelected={(option, value) => option.phone === value.phone}
                // valuek
                disableClearable
                getOptionLabel={(option) => option?.queryType}
                getOptionValue={(option) => option?.queryType}
                isOptionEqualToValue={(option, value) =>
                  option?.queryType === value?.queryType
                }
                onChange={(event, val) => {
                  setSelectMail(val);
                }}
                componentsProps={
                  {
                    // popper: { style: { width: "400px" } },
                  }
                }
                size="small"
                options={contactUsMails}
                autoHighlight
                renderOption={(props, option) => (
                  <Box
                    component="li"
                    sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                    {...props}
                  >
                    {option.queryType}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextFieldMA
                    name="password"
                    autoComplete="off"
                    {...params}
                    label="Select Query"
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: "new-password", // disable autocomplete and autofill
                    }}
                  />
                )}
              />
              {/* <TextFieldMA
                multiline
                rows={5}
                required
                fullWidth
                label="Query"
              /> */}
              <TextareaAutosize
                onChange={(e) => setContactUsQuery(e.target.value)}
                style={{
                  width: "100%",
                  resize: "none",
                  borderRadius: "4px",
                  border: `1px solid ${theme.col_2}`,
                  paddingLeft: "12px",
                  paddingTop: "12px",
                }}
                placeholder="Write your Query"
                id="textArea"
                maxRows={6}
                minRows={6}
              />
              <ButtonCustom
                borderRadius={"45px"}
                width={"83px"}
                height="35px"
                minWidth="83px"
                disabled={!selectMail || !contactUsQuery}
                // fullWidth={true}
                onClick={postContactUs}
                typography={
                  <Typography
                    fontFamily={font.family.fm_2}
                    textTransform={"capitalize"}
                    fontSize={font.size.fs_4}
                    fontWeight="bold"
                    color={theme.col_2}
                  >
                    Send
                  </Typography>
                }
                // onClick={handleDemo}
                background={theme.col_2_alpha}
                backgroundRipple={theme.col_2_alpha}
              />
            </Box>
          </Box>
        </Box>
      </Dialog>

      <GlobalSnackBar
        open={profileSnack}
        title={error}
        close={setProfileSnack}
      />
      <SubscriptionDialog
        selectedNoOfEmployees={selectedNoOfEmployees}
        paymentAmount={
          Number.isNaN(selectedNoOfEmployees) === false
            ? (
                (selectedNoOfEmployees > 185 ? 185 : selectedNoOfEmployees) *
                standardPlanPrice
              ).toFixed(2)
            : standardPlanPrice
        }
        // setSubDialog={setSubDialog}
        // setSubscriptionNav={setSubscriptionNav}
        // subscriptionNav={subscriptionNav}
        // setError={setError}
        // upgrade={true}
        // subDialog={subDialog}
        // handleClose={handleClose}
        // setProfileSnack={setProfileSnack}
      />
    </>
  );
};
